import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setAuthHeader } from './apiHelpers';
import { liveAppUrl, demoAppUrl, localAppUrl } from '../../config';

const currentURL = window.location.href;
const appURL = currentURL.includes('localhost') ? localAppUrl : currentURL.includes('glidix') ? demoAppUrl : liveAppUrl;

export const articleApi = createApi({
  reducerPath: 'articleApi',
  baseQuery: fetchBaseQuery({
    baseUrl: appURL,
    prepareHeaders: (headers) => {
      setAuthHeader(headers);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchArticle: builder.query({
      query: (params) => {
        if (params?.filter) {
          return `/article/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}&filter=${params?.filter}`;
        } else if (params?.search) {
          return `/article/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}&search=${params.search}`;
        } else {
          return `/article/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}`;
        }
      }
    }),
    fetchArticleDetail: builder.query({
      query: (id) => `/article/detail/${id}`,
    }),
    createArticle: builder.mutation({
      query: (credentials) => ({
        url: '/article/store',
        method: 'POST',
        body: credentials,
      }),
    }),
    updateArticle: builder.mutation({
      query: (credentials) => ({
        url: '/article/update',
        method: 'POST',
        body: credentials,
      }),
    }),
    deleteArticle: builder.mutation({
      query: (id) => ({
        url: `/article/delete/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useFetchArticleQuery,
  useFetchArticleDetailQuery,
  useCreateArticleMutation,
  useUpdateArticleMutation,
  useDeleteArticleMutation
} = articleApi;
